<script lang="ts">
    import NauiInput from "./../lib/naui/atoms/NauiInput.svelte";
    import NauiButton from "../lib/naui/atoms/NauiButton.svelte";
    import NauiDateRange from "../lib/naui/atoms/NauiDateRange.svelte";
    import { onMount } from "svelte";
    import NauiSelect from "../lib/naui/atoms/NauiSelect.svelte";
    import Dialog, { Actions, Content, Title } from "@smui/dialog";
    import AuditoriaTable from "./components/AuditoriaTable.svelte";
    import NauiTag from "../lib/naui/atoms/NauiTag.svelte";

    export let subruta;
    export let data = [];
    export let user_groups;

    let AuditoriaItems = [];
    let localData = [];
    let defectos = [];
    let defectosPrimeras = [];
    let defectosSegundas = [];
    let defectosDescargar = [];
    let dialogOpen = false;
    let mensaje;
    let buscando = false;
    let referencia = "";
    let rango = "";
    let estado_sel = "Programada";
    let vendor_sel = "0";
    let facturas = [];
    let vendors = [];
    
    let PO = "";
    const swAuditar = true;
    const isPaqueteCompleto = subruta === "paqueteCompleto";
    const isMaquila = subruta === "maquila";
    const proceso_auditado_paqueteCompleto = "Paquete Completo";
    const tipo_auditoria_primeras = "Primeras";
    const is_administrador_auditoria = user_groups.includes("administrador_auditorias");
 
    let estados = [
        {
            label: "Programada",
            value: "Programada",
        },
        {
            label: "Lote Fraccionado",
            value: "Lote Fraccionado",
        },
        {
            label: "Entrega Certificada",
            value: "Entrega Certificada",
        },
        {
            label: "Aprobado",
            value: "Aprobado",
        },
        {
            label: "Rechazado",
            value: "Rechazado",
        },
        {
            label: "Cancelado",
            value: "Cancelado",
        },

        ...(is_administrador_auditoria || user_groups.includes("sourcing") ? [{
            label: "Rechazo Por Confirmar",
            value: "Rechazo Por Confirmar",
        }] : []),
    ];

    let currentPage = 1;
    let totalPages = 1;
    const itemsPerPage = 20;
    const pagination = true;

    onMount(async () => {
        setTimeout(() => {
            document.getElementById("referencia").focus();
            document.getElementById("po").focus();
        }, 500);
        await loadData();
        await buscarDefectos();
        await buscar();
    });

    function loadData() {
        let vendors_concat = [];
        localData = data.map((x) => {
            return { ...x, checked: false };
        });

        vendors.push({ label: "TODOS", value: "0" });

        vendors_concat = localData.map((y) => {
            return {
            label: y.name,
            value: y.id,
            };
        }).sort((a, b) => a.label.localeCompare(b.label));

        vendors = vendors.concat(vendors_concat);
    }

    // Función para buscar auditables
    async function buscar(page = 1) {
        buscando = true;
        AuditoriaItems = [];
        const payload = {
            estado: estado_sel,
            vendor: vendor_sel,
            referencia: referencia,
            rango: rango,
            swAuditar: swAuditar,
            po: PO,
            procesoAuditado: subruta,
        };

        const response = await fetch(`/auditoria/buscar?pagination=${pagination}&page=${page}&per_page=${itemsPerPage}`, {
            method: "post",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(payload),
        });
        const result = await response.json();
        if (response.ok) {
            buscando = false;
            AuditoriaItems = result.data.map((x) => {
                return {
                    ...x,
                    checked: false,
                    lista_defectos:
                        x.tipo_auditoria === tipo_auditoria_primeras ||
                        x.proceso_auditado === proceso_auditado_paqueteCompleto
                            ? defectosPrimeras.map((d) => ({ ...d }))
                            : defectosSegundas.map((d) => ({ ...d })),
                };
            });
            currentPage = result.page;
            totalPages = result.pages;
            
        }
       
    }

    async function buscarDefectos() {
        let res = [];
        const response = await fetch("/auditoria/buscar_defectos", {
            method: "get",
            headers: {
                "content-type": "application/json",
            },
        });
        if (response.ok) {
            res = await response.json();
            defectos = res["data"];
            defectos = defectos;
            defectosPrimeras = defectos.filter(
                (x) => x.tipo_auditoria === "PRIMERAS",
            );
            defectosSegundas = defectos.filter(
                (x) => x.tipo_auditoria === "SEGUNDAS",
            );
        }
    }

    function cancelar() {
        document.location = `/auditoria/home/${subruta}`;
    }

    function calcularTotalPaginas(totalRegistros, cantidadItemsPagina) {
        let totalPaginas = Math.round(totalRegistros / cantidadItemsPagina);
        return totalPaginas == 0 ? totalPaginas + 1 : totalPaginas;
    }

    async function excel() {
        buscando = true;
        const payload = {
            estado: estado_sel,
            vendor: vendor_sel,
            referencia: referencia,
            rango: rango,
            swAuditar: swAuditar,
            po: PO,
            procesoAuditado: subruta,
        };

        const response = await fetch(
            "/auditoria/descargar_archivo_auditables",
            {
                method: "post",
                headers: {
                    "content-type": "application/json",
                },
                body: JSON.stringify(payload),
            },
        );
        if (response.ok) {
            buscando = false;
            const data = await response.arrayBuffer();
            const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = `Auditables_${new Date().toLocaleDateString()}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
        }
    }

    function nextPage() {
        if (currentPage < totalPages) {
            buscar(currentPage + 1);
        }
    }

    function prevPage() {
        if (currentPage > 1) {
            buscar(currentPage - 1);
        }
    }

    $: AuditoriaItems = AuditoriaItems;
</script>

<section>
    <table class="naui-table w-70">
        <tr>
            <td>
                <NauiSelect
                    bind:value={estado_sel}
                    options={estados}
                    label="Estado"
                />
            </td>
            <td>
                <NauiSelect
                    bind:value={vendor_sel}
                    options={vendors}
                    label="Vendor"
                />
            </td>
            {#if isPaqueteCompleto}
                <td>
                    <NauiInput id="po" bind:value={PO} label="PO" />
                </td>
            {/if}
            <td>
                <NauiInput
                    id="referencia"
                    bind:value={referencia}
                    label="Referencia"
                />
            </td>
            <td>
                <NauiDateRange
                    label="Buscar registros entre"
                    bind:value={rango}
                />
            </td>

            <td>
                <NauiButton
                    caption="Buscar Solicitudes"
                    mode="outline"
                    color="accent"
                    on:click={() => buscar()}
                />
            </td>
            <td>
                <NauiButton
                    caption="Descargar Excel"
                    mode="outline"
                    color="accent"
                    on:click={excel}
                />
            </td>

            <td>
                <div>
                    <NauiButton
                        caption="Cancelar"
                        mode="outline"
                        color="accent"
                        on:click={cancelar}
                    />
                </div>
            </td>
        </tr>
    </table>
    <AuditoriaTable
        bind:auditoriaItems={AuditoriaItems}
        bind:buscando
        itemsPerPage={itemsPerPage}
        totalPages={totalPages}
        on:buscar={(event) => buscar(event.detail.page)}
        {subruta}
        is_administrador_auditoria = {is_administrador_auditoria}
        currentPage = {currentPage}
    />
    <div class="prevNextPage">
        <button
            class={`${currentPage === 1 ?"disabled":""} btn outline accent`}
            icon="chevron_left"
            on:click={prevPage}
            disabled={currentPage === 1}
        ><span class="material-icons-outlined">chevron_left</span></button>

        <NauiTag 
            label={`Página ${currentPage} de ${totalPages}`}
        />

        <button
            class={`${currentPage === totalPages?"disabled":""} btn outline accent`}
            on:click={nextPage}
            disabled={currentPage === totalPages}
        ><span class="material-icons-outlined">chevron_right</span></button>

    </div>
    <Dialog bind:open={dialogOpen}>
        <Title>
            <h3 class="text-c">Auditar</h3>
        </Title>
        <Content>
            <div class="max-w-400px text-c mx-auto px-15">
                <p class="large">
                    {mensaje}
                </p>
            </div>
        </Content>
        <Actions>
            <div class="box-r sx-ii px-1 py-ii">
                <NauiButton
                    caption="Aceptar"
                    color="accent"
                    on:click={() => {
                        dialogOpen = false;
                    }}
                />
            </div>
        </Actions>
    </Dialog>
</section>

<style>
    .custom-input-file {
        margin: 15px auto 0;
        min-height: 15px;
        overflow: hidden;
        padding: 5px;
        position: relative;
        text-align: center;
        width: 300px;
        height: 40px;
    }

    .custom-input-file .input-file {
        border: 10000px solid transparent;
        cursor: pointer;
        font-size: 10000px;
        margin: 0;
        opacity: 0;
        outline: 0 none;
        padding: 0;
        position: absolute;
        right: -1000px;
        top: -1000px;
    }
    .prevNextPage{
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }

    .prevNextPage .disabled{
        background: #f4f5f6;
        border: unset;
    }

    .prevNextPage .disabled span{
        color: white;
    }

    .prevNextPage .disabled:hover{
        cursor: initial;
        border: initial;
    }
</style>